export default "__VITE_ASSET__fdf86c40__"